<template>
  <div>
    <q-dialog v-model="open">
      <q-card>
        <q-card-section>
          <div class="q-mb-sm text-body1 text-center text-weight-bold">
            <q-icon name="warning" class="text-orange fit justify-center" style="font-size: 2rem"></q-icon>
            {{ title }}
          </div>
          <div class="text-body2 text-center">
            {{ message }}
          </div>
        </q-card-section>
        <q-btn dense flat v-close-popup class="fit justify-center text-blue text-weight-bold" @click="open = false">
          OK
        </q-btn>
      </q-card>
    </q-dialog>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue'

interface Props {
  title: string
  message: string
  isOpen?: boolean
}

export default defineComponent<Props>({
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: false,
    },
  },
  setup(props) {
    const open = ref(!!props.isOpen)

    return { open }
  },
})
</script>
